import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Sheet } from "./Sheet";
import { LinkButton } from "./LinkButton";
import { CreditChip } from "./CreditChip";

export interface MastheadProps {
  /** Shown when the phone knows a balance. Marketing routes pass nothing. */
  credits?: number;
  creditsLow?: boolean;
}

const links = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/pricing", label: "Pricing" },
  { to: "/privacy", label: "Privacy" },
];

export function Masthead({ credits, creditsLow }: MastheadProps) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="masthead" data-scrolled={scrolled}>
      <div className="page masthead-in">
        <Link className="wordmark" to="/">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" aria-hidden="true">
            <rect x="2.5" y="2.5" width="21" height="21" rx="6.5" fill="var(--sage)" stroke="var(--ink)" strokeWidth="2.2" />
            <path d="M8 13h10M13 8v10" stroke="var(--ink)" strokeWidth="2.4" strokeLinecap="round" />
          </svg>
          MathsHub
        </Link>

        <nav className="masthead-nav" aria-label="Main">
          {links.map((link) => (
            <NavLink key={link.to} className="navlink" to={link.to}>
              {link.label}
            </NavLink>
          ))}
          <Link className="navlink" to="/signin">
            Sign in
          </Link>
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: "var(--s-2)" }}>
          {credits === undefined ? null : <CreditChip balance={credits} low={creditsLow} />}
          <button
            type="button"
            className="masthead-burger"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 7h16M4 12h16M4 17h16" stroke="var(--ink)" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>

      <Sheet open={open} onClose={() => setOpen(false)} title="Menu">
        <nav className="stack" aria-label="Menu">
          {links.map((link) => (
            <Link key={link.to} className="sheetlink" to={link.to} onClick={() => setOpen(false)}>
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="sheet-foot">
          <h3>Already have an account?</h3>
          <p className="lead">Signing in brings back your children, their pages and your credits.</p>
          <LinkButton to="/signin" tone="primary" onClick={() => setOpen(false)}>
            Sign in
          </LinkButton>
        </div>
      </Sheet>
    </header>
  );
}
